(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lookbook-gallery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const gallery = document.getElementById('stl-gallery-' + '{{ section.id }}');
    if (!gallery) return;
    gallery.querySelectorAll('.stl-card').forEach(card => {
      card.addEventListener('click', () => {
        const dialog = document.getElementById(card.dataset.open);
        if (dialog) { dialog.showModal(); document.body.style.overflow = 'hidden'; }
      });
    });
    gallery.querySelectorAll('.stl-popup__close').forEach(btn => {
      btn.addEventListener('click', () => btn.closest('dialog').close());
    });
    gallery.querySelectorAll('.stl-popup').forEach(dialog => {
      dialog.addEventListener('click', e => { if (e.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => { document.body.style.overflow = ''; });
    });
    gallery.querySelectorAll('.stl-product__atc').forEach(btn => {
      btn.addEventListener('click', async () => {
        const variantId = btn.dataset.variantId;
        if (!variantId) return;
        const orig = btn.textContent.trim();
        btn.textContent = '...'; btn.disabled = true;
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST', headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
          });
          if (res.ok) {
            btn.textContent = '\u2713 Ajouté'; btn.classList.add('stl-product__atc--success');
            document.dispatchEvent(new CustomEvent('cart:updated'));
            setTimeout(() => { btn.textContent = orig; btn.disabled = false; btn.classList.remove('stl-product__atc--success'); }, 2500);
          } else throw new Error();
        } catch { btn.textContent = 'Erreur'; setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 2000); }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
